<app-topmenu></app-topmenu>
<router-outlet></router-outlet>
<ngx-spinner type="line-scale-pulse-out-rapid" color="#0090d9" size="large"></ngx-spinner>